
import React, { Component } from 'react';
import Pause from 'components/Pause';
import AudioPlayer from 'components/AudioPlayer';
import strings from 'strings';

import introAfter from '../../assets/sounds/no/intros/SM_Intro-AFTER-trial.mp3';

class PauseAfterTrial extends Component {
  render() {
    return (
      <div className="PauseAfterTrial">
        <p>
  <AudioPlayer autoplay inline src={introAfter} />
  {strings.sm_intro_after_trial_1 ||
    'Nå har du øvd litt på denne oppgaven, så nå kan vi starte på de ordentlige setningene.'}
  <br />
  {strings.sm_intro_after_trial_2 ||
    'Nå får du bare høre hver setning én gang, så lytt ekstra godt etter.'}
  <br />
  {strings.sm_intro_after_trial_3 ||
    'Trykk på startknappen når du er klar.'}
</p>

       
        <Pause {...this.props} />
      </div>
    );
  }
}

export default PauseAfterTrial;
